module.exports = __webpack_public_path__ + "img/loading.b8509d6c.svg";